module.exports = __webpack_public_path__ + "img/bin-c-3-w.9adb31e2.svg";